import { render } from "./FoundationRemedialCountByStatus.vue?vue&type=template&id=c48b7b5e"
import script from "./FoundationRemedialCountByStatus.vue?vue&type=script&lang=js"
export * from "./FoundationRemedialCountByStatus.vue?vue&type=script&lang=js"
script.render = render

export default script